import React, { useEffect } from "react";
import MatchListing from "./common/liveCenter/matchListing/MatchListing";
import { ColorVariables } from "../utils/general";
import HorseRacingCard from "./horse-racing/HorseRacingCard";

// New wrapper components

const HorseRacingWidget = ({
    dataId,
    dataType,
    sport,
    difference,
    head,
    data,
    headData,
    baseUrl,
    loadCSS,
    setDataId,
    setDataType,
    setHead,
    setDate,
    date,
    setIsLive,
    isLive,
    dataClient = false,
    websiteBaseUrl,
    dataPath,
    dataTitle,
}) => {
    useEffect(() => {
        const loadSettings = async () => {
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: process.env.REACT_APP_SETTINGS_TOKEN,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                });

                if (!res.ok) throw new Error(res.statusText);

                const settings = await res.json();
                const cssVars = ColorVariables(settings);

                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);

                document.querySelectorAll(".microservice-cont")?.forEach((el) => el?.classList.add("hydrated"));


                return () => {
                    if (document.head.contains(styleTag)) {
                        document.head.removeChild(styleTag);
                    }
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };

        loadSettings();
    }, [baseUrl]);

    const commonProps = {
        dataId,
        dataType,
        sport,
        difference,
        head,
        data,
        headData,
        baseUrl,
        loadCSS,
        setDataId,
        setDataType,
        setHead,
        setDate,
        date,
        setIsLive,
        isLive,
        dataClient,
        websiteBaseUrl,
        dataPath,
        dataTitle,
    };

    if (dataType === "horse-racing-live") {
        return <MatchListing {...commonProps} data={data?.data} matchType="all" />;
    }


    if (dataType === ("horse-racing-cards")) {
        return <HorseRacingCard {...commonProps} />;
    }

    return <h1>Widget Not Found in Horse Racing !!</h1>;
};

export default HorseRacingWidget;
